<script>
	import { tick } from "svelte";
	import { projectSettings } from "../config";
	import { validator } from "../validation";

	export let id = null;
	export let label = null;
	export let sublabel = null;
	export let value = null;
	export let maxlength = null;
	export let required = false;
	export let disabled = false;
	export let placeholder = null;

	const authorization = `Basic ${projectSettings.loqateCredentials}`;

	let inputEl;
	let isValidating = false;
	let isValid = !!value;
	let retryCount = 0;
	let retryLimit = 2;
	let valueOnFocus = null;
	let wasInvalidOnFocus = false;
	let isBlurring = false;

	$: value = value ? value.toLowerCase() : value;

	async function validateEmailDomain(emailValue) {
		if (!emailValue) {
			return { success: true };
		}

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(emailValue)) {
			return { success: false };
		}

		const responseOptions = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: authorization
			},
			body: JSON.stringify({
				payload: [{ address: emailValue }],
				sourceOfTruth: "VE_ALL",
				featureOptions: { timeout: "1500" }
			})
		};

		try {
			const response = await fetch("https://hosted.mastersoftgroup.com/harmony/rest/au/validate/email", responseOptions);
			if (!response.ok) throw new Error("Loqate email validation failed");

			const responseData = await response.json();
			if (!responseData.payload?.length) throw new Error("Loqate email validation returned no result");

			const [{ reason = [] } = {}] = responseData.payload || [];
			const allowedReasons = [
				"mailbox_is_role_address",
				"unknown_provider",
				"immature_domain",
				"req_timeout",
				"smtp_timeout"
			];
			const isValidResponse = reason.every((validationReason) => allowedReasons.includes(validationReason));
			retryCount = 0;

			return { success: isValidResponse };
		} catch {
			if (retryCount++ >= retryLimit) {
				return { timeout: true };
			}

			return validateEmailDomain(emailValue);
		}
	}

	function showValidationError() {
		isValid = false;
		setTimeout(() => $validator.validate(inputEl), 0);
	}

	function handleFocus() {
		valueOnFocus = value;
		wasInvalidOnFocus = !isValid;
		isValid = true;
		isBlurring = false;
	}

	function handleBlur(event) {
		isBlurring = true;

		if (value !== valueOnFocus) {
			handleChange(event);
		} else if (wasInvalidOnFocus) {
			showValidationError();
		}
	}

	async function handleChange(event) {
		if (event && !event.isTrusted) return;
		if (isBlurring && event?.type === "change") return;

		isValid = false;
		$validator.clearVisualError(inputEl);
		isValidating = true;

		const emailValue = (event?.target?.value || value || "").trim();

		if (!emailValue) {
			await tick();
			isValidating = false;
			inputEl.dispatchEvent(new Event("change", { bubbles: true }));
			return;
		}

		try {
			const status = await validateEmailDomain(emailValue);
			isValid = status.success || status.timeout;
			await tick();
		} finally {
			isValidating = false;
			inputEl.dispatchEvent(new Event("change", { bubbles: true }));
		}
	}
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}
<input
	bind:this={inputEl}
	{id}
	class="form-control"
	type="email"
	{required}
	{disabled}
	{placeholder}
	{maxlength}
	bind:value
	data-validator="emailinput"
	data-isvalid={isValid}
	on:focus={handleFocus}
	on:blur={handleBlur} />

<div id="{id}_error" class="email-input-error">
	{#if isValidating}
		<div class="error-message" style="color:orange">Validating...</div>
	{/if}
</div>
